import { styled, Box, Typography } from '../../../base';

export const StyledDateRangePanel = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    boxShadow: theme.shadows[3],
}));

export const StyledPanelTitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.common.black,
    marginBottom: theme.spacing(1),
}));
